<template>
  <div class="d-flex align-self-center mx-auto flex-grow-1">
    <div class="d-flex flex-grow-1 align-self-center ml-6" style="max-width: 320px">
      <div class="d-flex flex-column flex-grow-1">
        <div v-if="error" class>
          <div class="alert alert-danger">
            <b>Error!</b>
            {{ error }}
          </div>
        </div>
        <div class>
          <div class>
            <h4 class="text-left mb-4">Starting interactive demo...</h4>
            <!-- <form @submit.prevent="signin">
              <div class="form-group">
                <label>Email</label>
                <input v-model="email" type="text" class="form-control form-control-lg" placeholder required readonly />
              </div>
              <div class="form-group">
                <input v-model="password" type="password" class="form-control form-control-lg" placeholder required readonly />
              </div>
              <button type="submit" class="btn btn-block btn-lg btn-primary mt-1" :disabled="isLoggingIn">
                {{ isLoggingIn ? 'Signing in...' : 'Sign In' }}
              </button>
            </form> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {},
  data() {
    return {
      email: 'demo@refera.com',
      password: 'ReferaPassword!123',
      isLoggingIn: false,
    }
  },
  computed: {
    ...mapState('auth', {
      error: (state) => state.error,
    }),
  },

  async mounted() {
    this.$store.dispatch('auth/clearError')
    this.signin()
  },

  methods: {
    async signin() {
      let _this = this
      this.$store.dispatch('auth/clearError')

      this.isLoggingIn = true
      try {
        await this.$store.dispatch('auth/loginWithPassword', {
          email: this.email,
          password: this.password,
        })
        this.$router.push(
          '/?tour=referralTour',
          () => (this.isLoggingIn = false)
        )
      } catch (e) {
        this.isLoggingIn = false
      }
    },
  },
}
</script>
<style scoped>
.form-group {
  margin-bottom: 25px;
}
.form-group label {
  color: var(--dark);
}
</style>
